import s from './Input.module.css';

export default function Textarea({ label, help, error, id, rows = 4, className = '', ...rest }) {
  const inputId = id || (label ? `ta-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
  return (
    <label className={s.field} htmlFor={inputId}>
      {label && <span className={s.label}>{label}</span>}
      <textarea
        id={inputId}
        rows={rows}
        className={`${s.textarea} ${error ? s.error : ''} ${className}`.trim()}
        {...rest}
      />
      {error && <span className={`${s.help} ${s.errorText}`}>{error}</span>}
      {!error && help && <span className={s.help}>{help}</span>}
    </label>
  );
}
